import { EPermissions } from '@/types/permissions.types';
import { BLAdmin } from '@/types/profile.types';
import { Get } from '../helpers';
import { createPath } from './utils';

export type BLAdminWithPermissions = Pick<BLAdmin, 'id' | 'email' | 'profile' | 'verified'> & {
  user_access: string[];
  roles: EPermissions[];
};

export type GetChannelAccessResponse = {
  data: BLAdminWithPermissions[];
  total: number;
};

export function GetChannelAccess(
  channel: number,
  page: number,
  limit = 20,
  search?: string,
  roleFilter?: EPermissions | ''
) {
  return Get<GetChannelAccessResponse>({
    path: createPath(channel, { page: page.toString(), limit: limit.toString(), search, roleFilter }),
  });
}
